
import { useEffect, useRef } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileCostView from './MobileCostView';
import DesktopCostView from './DesktopCostView';
import { createParticles, animateParticles, animateDesktopCostBars } from '@/utils/CostUtils';

const CostSavingsVisualization = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const particlesRef = useRef<HTMLDivElement>(null);
  const animationFrameRef = useRef<number>();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!containerRef.current || !particlesRef.current) return;
    
    // Create particles
    createParticles(particlesRef, isMobile);
    
    // Start animation
    animateParticles(particlesRef, isMobile, animationFrameRef);
    
    if (!isMobile) {
      // Desktop animation for cost bars
      animateDesktopCostBars(containerRef);
    }
    
    // Clean up
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [isMobile]);

  return (
    <div className="relative w-full max-w-5xl mx-auto mb-12" ref={containerRef}>
      {isMobile ? (
        <MobileCostView particlesRef={particlesRef} />
      ) : (
        <DesktopCostView particlesRef={particlesRef} />
      )}
    </div>
  );
};

export default CostSavingsVisualization;
